<template>
  <div class="numone">
    <div v-if="!resetshow">
      <!-- <div class="change" >
    <div   @click="changetry()">
      <div v-if="changeshow" class="cursorPointer">短信登录</div>
      <div v-if="!changeshow" class="cursorPointer">密码登录</div> 
    </div>
    
  </div> -->

      <el-tabs type="border-card" v-model="activeNameOut">
        <el-tab-pane label="个人登录" name="user">
          <div>
            <el-radio-group
              v-model="radio1"
              @input="changeLogin()"
              style="margin-bottom: 30px"
            >
              <el-radio-button label="密码登录"></el-radio-button>
              <el-radio-button label="短信登录"></el-radio-button>
            </el-radio-group>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              v-if="mima"
            >
              <!-- <el-form-item>
     
      <div class="title"  >
        <div v-if="titleshow">密码登录</div>
        <div v-if="!titleshow">短信登录</div>
      </div>
    </el-form-item> -->

              <!-- 密码登录表单div -->
              <div>
                <el-form-item prop="mobile">
                  <el-input
                    v-model="ruleForm.mobile"
                    autocomplete="off"
                    placeholder="请输入手机号"
                    prefix-icon="el-icon-user-solid"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="ruleForm.password"
                    autocomplete="off"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="sendi">
                  <div class="vidid">
                    <el-input
                      v-model="ruleForm.sendi"
                      placeholder="请输入图形验证码"
                      prefix-icon="el-icon-success"
                    ></el-input>
                    <div class="vidi" @click="getimgcode">
                      <img :src="ruleForm.sendiimg" alt="" />
                    </div>
                  </div>
                </el-form-item>

                <!-- 底部提交按钮 -->
                <el-form-item>
                  <el-button
                    class="el-button"
                    :class="{ iscolorshow: iscolor == true }"
                    @click="submitForm('ruleForm')"
                    style="width: 100%"
                  >
                    登录
                  </el-button>

                  <!-- 下面为清空表单内容 -->
                  <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                </el-form-item>
              </div>
            </el-form>

            <!-- 短信登录表单div -->
            <el-form
              :model="ruleFormtwo"
              :rules="rules"
              ref="ruleFormtwo"
              v-if="message"
            >
              <div>
                <el-form-item prop="mobiletwo">
                  <el-input
                    placeholder="请输入手机号"
                    v-model="ruleFormtwo.mobiletwo"
                    prefix-icon="el-icon-user-solid"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="senditwoimg">
                  <div class="vidid">
                    <el-input
                      v-model="ruleFormtwo.senditwoimg"
                      placeholder="请输入图形验证码"
                      prefix-icon="el-icon-success"
                    >
                    </el-input>
                    <div class="vidi" @click="getimgcode">
                      <img :src="ruleFormtwo.sendiimg" alt="" />
                    </div>
                  </div>
                </el-form-item>

                <el-form-item prop="senditwo">
                  <div class="vididd">
                    <el-input
                      placeholder="请输入验证码"
                      v-model="ruleFormtwo.senditwo"
                      prefix-icon="el-icon-key"
                      autocomplete="off"
                    ></el-input>
                    <el-button
                      class="send"
                      @click="getmobilecode"
                      :disabled="notsendi"
                    >
                      <span v-if="sended">{{ countdown }}后重新获取</span>
                      <span v-else>获取验证码</span>
                    </el-button>
                  </div>
                </el-form-item>

                <!-- 底部提交按钮 -->
                <el-form-item>
                  <el-button
                    class="el-button"
                    :class="{ iscolorshow: iscolorsend == true }"
                    @click="submitFormtwo('ruleFormtwo')"
                    style="width: 100%"
                  >
                    登录
                  </el-button>
                  <!-- 下面为清空表单内容 -->
                  <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                </el-form-item>
              </div>
            </el-form>

            <!-- notshowreset 控制是否显示 找回密码 -->
            <!-- <button v-if="notshowreset" class="resetpassword" @click="resetpwd">找回密码</button> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="组织登录" name="organazation">
          <div>
            <el-radio-group
              v-model="orgRadio"
              @input="orgchangeLogin()"
              style="margin-bottom: 30px"
            >
              <el-radio-button label="密码登录"></el-radio-button>
              <el-radio-button label="短信登录"></el-radio-button>
            </el-radio-group>
            <el-form
              :model="orgruleForm"
              :rules="rules"
              ref="orgruleForm"
              v-if="orgmima"
            >
              <!-- <el-form-item>
     
      <div class="title"  >
        <div v-if="titleshow">密码登录</div>
        <div v-if="!titleshow">短信登录</div>
      </div>
    </el-form-item> -->

              <!-- 密码登录表单div -->
              <div>
                <el-form-item prop="mobile">
                  <el-input
                    v-model="orgruleForm.mobile"
                    autocomplete="off"
                    placeholder="请输入手机号"
                    prefix-icon="el-icon-user-solid"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="orgruleForm.password"
                    autocomplete="off"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="sendi">
                  <div class="vidid">
                    <el-input
                      v-model="orgruleForm.sendi"
                      placeholder="请输入图形验证码"
                      prefix-icon="el-icon-success"
                    >
                    </el-input>
                    <div class="vidi" @click="getimgcode">
                      <img :src="orgruleForm.sendiimg" alt="" />
                    </div>
                  </div>
                </el-form-item>

                <!-- 底部提交按钮 -->
                <el-form-item>
                  <el-button
                    class="el-button"
                    :class="{ iscolorshow: iscolor == true }"
                    @click="submitForm('orgruleForm')"
                    style="width: 100%"
                  >
                    登录
                  </el-button>

                  <!-- 下面为清空表单内容 -->
                  <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                </el-form-item>
              </div>
            </el-form>

            <!-- 短信登录表单div -->
            <el-form
              :model="orgruleFormtwo"
              :rules="rules"
              ref="orgruleFormtwo"
              v-if="orgmessage"
            >
              <div>
                <el-form-item prop="mobiletwo">
                  <el-input
                    placeholder="请输入手机号"
                    v-model="orgruleFormtwo.mobiletwo"
                    prefix-icon="el-icon-user-solid"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="senditwoimg">
                  <div class="vidid">
                    <el-input
                      v-model="orgruleFormtwo.senditwoimg"
                      placeholder="请输入图形验证码"
                      prefix-icon="el-icon-success"
                    >
                    </el-input>
                    <div class="vidi" @click="getimgcode">
                      <img :src="orgruleFormtwo.sendiimg" alt="" />
                    </div>
                  </div>
                </el-form-item>

                <el-form-item prop="senditwo">
                  <div class="vididd">
                    <el-input
                      placeholder="请输入验证码"
                      v-model="orgruleFormtwo.senditwo"
                      prefix-icon="el-icon-key"
                      autocomplete="off"
                    ></el-input>
                    <el-button
                      class="send"
                      @click="orggetmobilecode"
                      :disabled="notsendi"
                    >
                      <span v-if="sended">{{ countdown }}后重新获取</span>
                      <span v-else>获取验证码</span>
                    </el-button>
                  </div>
                </el-form-item>

                <!-- 底部提交按钮 -->
                <el-form-item>
                  <el-button
                    class="el-button"
                    :class="{ iscolorshow: iscolorsend == true }"
                    @click="submitFormtwo('orgruleFormtwo')"
                    style="width: 100%"
                  >
                    登录
                  </el-button>
                  <!-- 下面为清空表单内容 -->
                  <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                </el-form-item>
              </div>
            </el-form>

            <!-- notshowreset 控制是否显示 找回密码 -->
            <!-- <button v-if="notshowreset" class="resetpassword" @click="resetpwd">找回密码</button> -->
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 找回密码 -->
    <div v-if="false">
      <el-form :model="ruleFormthree" :rules="rules" ref="ruleFormthree">
        <button class="resetchange" @click="gobacklogin">返回登录</button>
        <el-form-item>
          <div class="title">找回密码</div>
        </el-form-item>
        <div>
          <el-form-item prop="mobilethree">
            <el-input
              v-model="ruleFormthree.mobilethree"
              autocomplete="off"
              placeholder="请输入手机号"
              prefix-icon="el-icon-user-solid"
            ></el-input>
          </el-form-item>

          <el-form-item prop="sendi">
            <div class="vidid">
              <el-input
                v-model="ruleFormthree.sendi"
                placeholder="请输入图形验证码"
                prefix-icon="el-icon-success"
              ></el-input>
              <div class="vidi" @click="getimgcode">
                <img :src="ruleFormthree.sendiimg" alt="" />
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="senditwo">
            <div class="vididd">
              <el-input
                placeholder="请输入短信验证码"
                v-model="ruleFormthree.senditwo"
                prefix-icon="el-icon-key"
                autocomplete="off"
              ></el-input>
              <el-button
                class="send"
                @click="resetgetmobilecode"
                :disabled="resetnotsendi"
              >
                <span v-if="resetsended">{{ resetcountdown }}后重新获取</span>
                <span v-else>获取验证码</span>
              </el-button>
            </div>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="ruleFormthree.password"
              autocomplete="off"
              placeholder="请输入6-14位数字与字母密码"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>

          <el-form-item prop="passwordagain">
            <el-input
              type="password"
              v-model="ruleFormthree.passwordagain"
              autocomplete="off"
              placeholder="请再次输入密码"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="el-button"
              :class="{ iscolorshow: iscolorreset == true }"
              @click="submitFormthree('ruleFormthree')"
              style="width: 100%"
            >
              确认
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import request from '../utils/request';
  import broadcastChannel from '@/mixins/broadcastChannel';

  export default {
    mixins: [broadcastChannel],
    data() {
      // 密码方式登录校验汇总
      // 手机号自定义校验
      var validatemobile = (rule, value, callback) => {
        let str = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (value === '') {
          callback(new Error('请输入手机号'));
        }
        if (str.test(value) == false) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      // 密码自定义校验
      var validatepassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        }
        if (value.length < 6 || value.length > 16) {
          callback(new Error('请输入6-16位密码'));
        }
        // if(value == "111111" || value == "666666" || value == "000000" || value == "123456"){
        //   callback(new Error('密码强度过低，请更换'));
        // }
        else {
          callback();
        }
      };
      // 图片验证码自定义校验(密码登录)
      var validatesendi = (rule, value, callback) => {
        if (this.activeNameOut == 'user') {
          if (!value) {
            return callback(new Error('请输入图形验证码'));
          }
          if (value !== this.ruleForm.captchaCode) {
            return callback(new Error('请输入正确的图形验证码'));
          } else {
            callback();
            return "ok"
          }
        } else {
          if (!value) {
            return callback(new Error('请输入图形验证码'));
          }
          if (value !== this.orgruleForm.captchaCode) {
            return callback(new Error('请输入正确的图形验证码'));
          } else {
            callback();
            return "ok"
          }
        }

      };
      // 组织图片验证码自定义校验(密码登录)
      var orgvalidatesendi = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入图形验证码'));
        }
        if (value !== this.orgruleForm.captchaCode) {
          return callback(new Error('请输入正确的图形验证码'));
        } else {
          callback();
          return "ok"
        }
      };
      // 图片验证码自定义校验（短信登录）
      var validatesenditwotwo = (rule, value, callback) => {
        if (this.activeNameOut == 'user') {
          if (!value) {
            return callback(new Error('请输入图形验证码'));
          }
          if (value !== this.ruleFormtwo.captchaCode) {
            return callback(new Error('请输入正确的图形验证码'));
          } else {
            callback();
            return "ok"
          }
        } else {
          if (!value) {
            return callback(new Error('请输入图形验证码'));
          }
          if (value !== this.orgruleFormtwo.captchaCode) {
            return callback(new Error('请输入正确的图形验证码'));
          } else {
            callback();
            return "ok"
          }
        }

      };
      // 组织图片验证码自定义校验（短信登录）
      var orgvalidatesenditwotwo = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入图形验证码'));
        }
        if (value !== this.orgruleFormtwo.captchaCode) {
          return callback(new Error('请输入正确的图形验证码'));
        } else {
          callback();
          return "ok"
        }
      };

      // 图片验证码自定义校验（找回密码）
      var validatesendithree = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入图形验证码'));
        }
        if (value !== this.ruleFormthree.captchaCode) {
          return callback(new Error('请输入正确的图形验证码'));
        } else {
          callback();
          return "ok"
        }
      };
      // 短信方式登录校验汇总
      // 手机号自定义校验
      var validatemobiletwo = (rule, value, callback) => {
        let str = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (value === '') {
          callback(new Error('请输入手机号'));
        }
        if (str.test(value) == false) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      // 手机验证码自定义校验
      var validatesenditwo = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入验证码'));
        }
        if (value.length !== 4) {
          callback(new Error('请输入正确的验证码'));
        } else {
          callback();
        }
      };
      //找回密码校验
      // 再次密码自定义校验
      var validatepasswordagain = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        }
        if (value !== this.ruleFormthree.password) {
          callback(new Error('两次密码输入不一致'));
        } else {
          callback();
        }
      };

      return {
        radio1: '密码登录',
        orgRadio: '密码登录',
        mima: true,
        message: false,
        orgmima: true,
        orgmessage: false,
        activeNameOut: 'user',
        activeName: 'mima',
        // titleshow: true,
        // changeshow: true,
        resetshow: false, //显示找回密码 / 登录
        notshowreset: true, //控制是否显示 找回密码
        sended: false, //是否显示验证码已发送状态(短信登录 定时器) 
        resetsended: false, //是否显示验证码已发送状态(找回密码 定时器) 
        countdown: 60, //短信验证码倒计时（短信登录）
        resetcountdown: 60, //短信验证码倒计时 (找回密码) 
        notsendi: false, //短信验证码是否可发送获取(短信登录 定时器) 
        resetnotsendi: false, //短信验证码是否可发送获取(找回密码 定时器) 
        timer: null, // 定时器（卸载时销毁 置空）
        // 是否更改按钮颜色 （通过表单验证则更改按钮颜色）
        iscolor: false, //密码登录
        iscolorsend: false, // 短信登录
        iscolorreset: false, //找回密码
        // 密码登录表单数据
        ruleForm: {
          mobile: '',
          password: '',
          sendi: '', //图形验证码 用于表单提交
          sendiimg: "", //图形验证码图片
          uuid: "", //获取短信验证码时需回传图形验证码的uuid
          captchaCode: "", //正确的图形验证码 用于校验
        },
        // 短信登录表单数据
        ruleFormtwo: {
          mobiletwo: "",
          senditwo: "", // 短信验证码
          senditwoimg: '', //图形验证码 用于表单提交
          sendiimg: "", //图形验证码图片
          uuid: "", //获取短信验证码时需回传图形验证码的uuid
          captchaCode: "", //正确的图形验证码 用于校验
        },
        // 组织密码登录表单数据
        orgruleForm: {
          mobile: '',
          password: '',
          sendi: '', //图形验证码 用于表单提交
          sendiimg: "", //图形验证码图片
          uuid: "", //获取短信验证码时需回传图形验证码的uuid
          captchaCode: "", //正确的图形验证码 用于校验
        },
        // 短信登录表单数据
        orgruleFormtwo: {
          mobiletwo: "",
          senditwo: "", // 短信验证码
          senditwoimg: '', //图形验证码 用于表单提交
          sendiimg: "", //图形验证码图片
          uuid: "", //获取短信验证码时需回传图形验证码的uuid
          captchaCode: "", //正确的图形验证码 用于校验
        },
        // 找回密码
        ruleFormthree: {
          mobilethree: "",
          senditwo: "", //短信验证码
          password: '',
          passwordagain: "", //再一次输入密码

          sendi: '', //图形验证码 用于表单提交
          sendiimg: "", //图形验证码图片
          uuid: "", //获取短信验证码时需回传
          captchaCode: "", //正确的图形验证码 用于校验
        },
        rules: {
          mobile: [{
            validator: validatemobile,
            trigger: 'blur'
          }],
          password: [{
            validator: validatepassword,
            trigger: 'blur'
          }],
          sendi: [{
            validator: validatesendi,
            trigger: 'blur'
          }],
          // ss
          orgsendi: [{
            validator: orgvalidatesendi,
            trigger: 'blur'
          }],
          // 短信登录的数据验证
          mobiletwo: [{
            validator: validatemobiletwo,
            trigger: 'blur'
          }],
          senditwo: [{
            validator: validatesenditwo,
            trigger: 'blur'
          }],
          senditwoimg: [{
            validator: validatesenditwotwo,
            trigger: 'blur'
          }],
          // ss
          orgsenditwoimg: [{
            validator: orgvalidatesenditwotwo,
            trigger: 'blur'
          }],
          // 找回密码
          mobilethree: [{
            validator: validatemobile,
            trigger: 'blur'
          }],
          password: [{
            validator: validatepassword,
            trigger: 'blur'
          }],
          passwordagain: [{
            validator: validatepasswordagain,
            trigger: 'blur'
          }],
          // 短信验证码
          senditwo: [{
            validator: validatesenditwo,
            trigger: 'blur'
          }],
          // 图形验证码
          sendi: [{
            validator: validatesendithree,
            trigger: 'blur'
          }],
        },

      };
    },
    destroyed() {
      // 清除定时器
      clearTimeout(this.timer)
      this.timer = null
    },
    created() {
      // 页面初始化时 获取图形验证码
      this.getimgcode()
    },
    watch: {
      "ruleForm": {
        deep: true,
        handler(newValue, oldValue) {
          // 判断是否通过校验 通过则将动态类名触发
          if (/^[1][3,5,7,8][0-9]{9}$/.test(this.ruleForm.mobile) && this.ruleForm.password.length > 5 && this.ruleForm
            .sendi == this.ruleForm.captchaCode) {
            this.iscolor = true
          } else {
            this.iscolor = false
          }
        }
      },
      "ruleFormtwo": {
        deep: true,
        handler(newValue, oldValue) {
          // 判断是否通过校验 通过则将动态类名触发
          if (/^[1][3,5,7,8][0-9]{9}$/.test(this.ruleFormtwo.mobiletwo) && this.ruleFormtwo.senditwo.length == 4 && this
            .ruleFormtwo.senditwoimg == this.ruleFormtwo.captchaCode) {
            this.iscolorsend = true
          } else {
            this.iscolorsend = false
          }
        }
      },
      "orgruleForm": {
        deep: true,
        handler(newValue, oldValue) {
          // 判断是否通过校验 通过则将动态类名触发
          if (/^[1][3,5,7,8][0-9]{9}$/.test(this.orgruleForm.mobile) && this.orgruleForm.password.length > 5 && this
            .orgruleForm
            .sendi == this.orgruleForm.captchaCode) {
            this.iscolor = true
          } else {
            this.iscolor = false
          }
        }
      },
      "orgruleFormtwo": {
        deep: true,
        handler(newValue, oldValue) {
          // 判断是否通过校验 通过则将动态类名触发
          if (/^[1][3,5,7,8][0-9]{9}$/.test(this.orgruleFormtwo.mobiletwo) && this.orgruleFormtwo.senditwo.length ==
            4 && this
            .orgruleFormtwo.senditwoimg == this.orgruleFormtwo.captchaCode) {
            this.iscolorsend = true
          } else {
            this.iscolorsend = false
          }
        }
      },
      "ruleFormthree": {
        deep: true,
        handler(newValue, oldValue) {
          // 判断是否通过校验 通过则将动态类名触发
          if (/^[1][3,5,7,8][0-9]{9}$/.test(this.ruleFormthree.mobilethree) && this.ruleFormthree.password.length > 5 &&
            this.ruleFormthree.passwordagain == this.ruleFormthree.password && this.ruleFormthree.senditwo.length ==
            4 && this.ruleFormthree.sendi == this.ruleFormtwo.captchaCode) {
            this.iscolorreset = true
          } else {
            this.iscolorreset = false
          }
        }
      },
    },
    methods: {
      changeLogin() {
        if (this.radio1 == '密码登录') {
          this.mima = true
          this.message = false
        }
        if (this.radio1 == '短信登录') {
          this.mima = false
          this.message = true
        }
      },
      orgchangeLogin() {
        if (this.orgRadio == '密码登录') {
          this.orgmima = true
          this.orgmessage = false
        }
        if (this.orgRadio == '短信登录') {
          this.orgmima = false
          this.orgmessage = true
        }
      },
      // 更改登录方式事件
      // changetry(){
      //   this.changeshow = !this.changeshow,
      //   this.titleshow = !this.titleshow
      //   this.notshowreset = !this.notshowreset  //控制是否显示找回密码
      // },
      // 获取图形验证码
      async getimgcode() {
        const {
          data
        } = await request({
          method: "GET",
          url: `/captchaImage`,
        })
        // 密码登录页
        this.ruleForm.sendiimg = `data:image/jpg;base64,${data.img}`
        this.ruleForm.uuid = data.uuid
        this.ruleForm.captchaCode = data.captchaCode
        // 短信登录页：
        this.ruleFormtwo.sendiimg = `data:image/jpg;base64,${data.img}`
        this.ruleFormtwo.uuid = data.uuid
        this.ruleFormtwo.captchaCode = data.captchaCode
        // 组织密码登录页
        this.orgruleForm.sendiimg = `data:image/jpg;base64,${data.img}`
        this.orgruleForm.uuid = data.uuid
        this.orgruleForm.captchaCode = data.captchaCode
        // 组织短信登录页：
        this.orgruleFormtwo.sendiimg = `data:image/jpg;base64,${data.img}`
        this.orgruleFormtwo.uuid = data.uuid
        this.orgruleFormtwo.captchaCode = data.captchaCode
        // 找回密码页
        this.ruleFormthree.sendiimg = `data:image/jpg;base64,${data.img}`
        this.ruleFormthree.uuid = data.uuid
        this.ruleFormthree.captchaCode = data.captchaCode
      },

      // 获取短信验证码
      async getmobilecode() {
        if (this.ruleFormtwo.mobiletwo.length == "11" && /^[1][3,5,7,8][0-9]{9}$/.test(this.ruleFormtwo.mobiletwo) &&
          this.ruleFormtwo.senditwoimg == this.ruleFormtwo.captchaCode) {
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/sendPhoneCaptcha`,
            params: {
              phoneNumber: this.ruleFormtwo.mobiletwo,
              captchaCode: this.ruleFormtwo.senditwoimg,
              uuid: this.ruleFormtwo.uuid
            }
          })
          // 调用倒计时函数
          this.settime()
          this.notsendi = true //不可获取 设置为已发送状态

        } else { //失败提示消息
          this.$alert('请完善正确的手机号或图形验证码', '提示', {
            confirmButtonText: '确定',
            center: true,
            confirmButtonClass: "el-button--success",
          });
        }
      },
      // 组织获取短信验证码
      async orggetmobilecode() {
        if (this.orgruleFormtwo.mobiletwo.length == "11" && /^[1][3,5,7,8][0-9]{9}$/.test(this.orgruleFormtwo
            .mobiletwo) &&
          this.orgruleFormtwo.senditwoimg == this.orgruleFormtwo.captchaCode) {
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/sendPhoneCaptcha`,
            params: {
              phoneNumber: this.orgruleFormtwo.mobiletwo,
              captchaCode: this.orgruleFormtwo.senditwoimg,
              uuid: this.orgruleFormtwo.uuid
            }
          })
          // 调用倒计时函数
          this.settime()
          this.notsendi = true //不可获取 设置为已发送状态

        } else { //失败提示消息
          this.$alert('请完善正确的手机号或图形验证码', '提示', {
            confirmButtonText: '确定',
            center: true,
            confirmButtonClass: "el-button--success",
          });
        }
      },
      // 倒计时函数
      settime() {
        // 逻辑： 只有当定时器走完60s
        if (this.countdown == 0) {
          this.notsendi = false
          this.sended = false
          // this.$refs.sendout.innerHTML = "获取验证码"
          this.countdown = 60
          return
        } else {
          this.notsendi = true
          this.sended = true
          // this.$refs.sendout.innerHTML = `${this.countdown}后重新获取`
          this.countdown--
        }
        let that = this
        // 外层函数内部的this是vue实例
        this.timer = setTimeout(function () {
          // 内层函数的this是调用者 不是vue实例了(这里就是window)
          that.settime()
        }, 1000)
      },
      // 找回密码页 获取短信
      async resetgetmobilecode() {
        if (this.ruleFormthree.mobilethree.length == "11" && /^[1][3,5,7,8][0-9]{9}$/.test(this.ruleFormthree
            .mobilethree) && this.ruleFormthree.sendi == this.ruleFormthree.captchaCode) {
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/sendPhoneCaptcha`,
            params: {
              phoneNumber: this.ruleFormthree.mobilethree,
              captchaCode: this.ruleFormthree.sendi,
              uuid: this.ruleFormthree.uuid
            }
          })
          // 调用倒计时函数
          this.resetsettime()
          this.resetnotsendi = true //不可获取 设置为已发送状态

        } else { //失败提示消息
          this.$alert('请完善正确的手机号或图形验证码', '提示', {
            confirmButtonText: '确定',
            center: true,
            confirmButtonClass: "el-button--success",
          });
        }
      },
      // 找回密码页 倒计时函数
      resetsettime() {
        // 逻辑： 只有当定时器走完60s
        if (this.countdown == 0) {
          this.resetnotsendi = false
          this.resetsended = false
          // this.$refs.sendout.innerHTML = "获取验证码"
          this.countdown = 60
          return
        } else {
          this.resetnotsendi = true
          this.resetsended = true
          // this.$refs.sendout.innerHTML = `${this.countdown}后重新获取`
          this.resetcountdown--
        }
        let that = this
        // 外层函数内部的this是vue实例
        this.timer = setTimeout(function () {
          // 内层函数的this是调用者 不是vue实例了(这里就是window)
          that.resetsettime()
        }, 1000)
      },
      // 获取个人用户信息(存入vuex)
      async getpersoninfoall(id) {
        const {
          data
        } = await request({
          url: "/customer/PersonalUserInfo/getInfo",
          method: "POST",
          params: {
            personId: id,
          }
        })
        if (data.code == 200) {
          if (data.data.idCardNo == null) {
            this.$confirm('请先完善个人信息', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({
              path: '/infostartperson/playerinfo'
            })
            }).catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // });
            });
          }
          // 将数据存到vuex中
          this.$store.commit("updatepersonInfo", data.data || {})
        }

      },

      // 获取机构用户信息(存入vuex)
      async getorganinfo(id) {
        const {
          data
        } = await request({
          url: "/customer/OrgUserInfo/getInfo",
          method: "POST",
          params: {
            orgId: id,
          }
        })
        // 将数据存到vuex中
        this.$store.commit("updateorganInfo", data.data || {})
      },

      //密码登录方式表单提交事件
      submitForm(formName) {
        let params = {}
        if (formName == 'ruleForm') {
          params = {
            "account": this.ruleForm.mobile,
            "password": this.$md5(this.ruleForm.password),
            "type": 1,
          }
        }
        if (formName == 'orgruleForm') {
          params = {
            "account": this.orgruleForm.mobile,
            "password": this.$md5(this.orgruleForm.password),
            "type": 2,
          }
        }
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            // 发起请求 传送表单数据
            const {
              data
            } = await request({
              method: "POST",
              url: `/customer/login`,
              params: params
            })
            if (data.code == 200) {
              await this.$alert('成功登录', {
                confirmButtonText: '确定',
                center: true,
                confirmButtonClass: "el-button--success",
              });

              // 将token存入vuex 
              this.$store.commit("savetoken", true)
              // 将数据存到vuex
              // 账号信息
              this.$store.commit("updateaccountInfo", data.data.accountInfo)
              // 用户信息
              this.$store.commit("updatepersonInfo", data.data.personInfo || {})
              // 机构信息
              this.$store.commit("updateorganInfo", data.data.orgInfo || {})
              // 用户和机构 只有有一个有值  所以要进行判断  不然underfind点任何数据都会报错 找不到
              if (data.data.personInfo) {
                // 通过id获取用户信息 并存到vuex中
                this.getpersoninfoall(data.data.personInfo.id || "")
              } else {
                // 通过id获取机构信息 并存到vuex中
                this.getorganinfo(data.data.orgInfo.id || "")
              }
              // 关闭弹层 跳转首页之前 先将滚动置0 防止进入首页时出现闪白情况
              // document.documentElement.scrollTop = 0    //登录先不做  因为无论怎样都会闪白
              // 关闭弹层  子传父 (父组件处理登未登录显示状态)
              this.$emit("closelogin", false)
              this.broadcastChannel.postMessage('refresh');
              // 路由跳转至首页
              // this.$router.push({ path:'/'})

            } else if (data.msg == "账号不存在") {
              this.$alert('账号不存在，请重试', {
                confirmButtonText: '确定',
                center: true,
                confirmButtonClass: "el-button--success",
              });
            } else if (data.msg == "密码错误") {
              this.$alert('密码错误，请重试', {
                confirmButtonText: '确定',
                center: true,
                confirmButtonClass: "el-button--success",
              });
            } else {
              this.$alert('登录异常，请重试', {
                confirmButtonText: '确定',
                center: true,
                confirmButtonClass: "el-button--success",
              });
            }
            // 13125419915
          } else {
            return false;
          }
        });
      },
      //短信方式表单提交事件
      submitFormtwo(formName) {
        let params = {}
        if (formName == 'ruleFormtwo') {
          params = {
            "account": this.ruleFormtwo.mobiletwo,
            "smsCode": this.ruleFormtwo.senditwo,
            "type": 1,
          }
        }
        if (formName == 'orgruleFormtwo') {
          params = {
            "account": this.orgruleFormtwo.mobiletwo,
            "smsCode": this.orgruleFormtwo.senditwo,
            "type": 2,
          }
        }
        this.$refs[formName].validate(async (valid) => {
          // 发起请求 传送表单数据
          if (valid) {
            // 发起请求 传送表单数据
            const {
              data
            } = await request({
              method: "POST",
              url: `/customer/smsLogin`,
              params: params
            })

            if (data.code == 200) {
              await this.$alert('成功登录', {
                confirmButtonText: '确定',
                center: true,
                confirmButtonClass: "el-button--success",
              });

              // 将token存入vuex
              this.$store.commit("savetoken", true)
              // 将数据存到vuex
              // 账号信息
              this.$store.commit("updateaccountInfo", data.data.accountInfo)
              // 用户信息
              this.$store.commit("updatepersonInfo", data.data.personInfo || {})
              // 机构信息
              this.$store.commit("updateorganInfo", data.data.orgInfo || {})
              // 关闭弹层  子传父 并更改登录显示状态
              this.$emit("closelogin", false)
              // 路由跳转至首页
              // this.$router.push({ path:'/'})
              this.broadcastChannel.postMessage('refresh');
            } else if (data.msg == "短信验证码不正确") {
              this.$alert('短信验证码不正确，请重试', {
                confirmButtonText: '确定',
                center: true,
                confirmButtonClass: "el-button--success",
              });
            } else if (data.msg == "账号不存在") {
              this.$alert('账号不存在，请注册', {
                confirmButtonText: '确定',
                center: true,
                confirmButtonClass: "el-button--success",
              });
            }
          } else {
            return false;
          }
        });
      },
      // 找回密码 表单提交事件
      async submitFormthree() {
        await this.$alert('抱歉，该功能处于维护中，请使用短信方式登录', {
          confirmButtonText: '确定',
          center: true,
          confirmButtonClass: "el-button--success",
        });
        // 跳转到登录页
        this.resetshow = false
        // this.$refs[formName].validate(async(valid) => {
        //   if (valid) {
        //     const {data} = await request({
        //       method:"POST",
        //       url: `/customer/register`,
        //       params:{
        //           "account": this.ruleFormthree.mobilethree,
        //           "password":this.$md5(this.ruleFormthree.password),
        //           "type": 1,
        //           "smsCode": this.ruleFormthree.senditwo,
        //       }
        //     })
        //     console.log(data)
        //     if(data.code == 200){
        //       await this.$alert('提交成功,请登录',  {
        //           confirmButtonText: '确定',
        //           center:true,
        //           confirmButtonClass:"el-button--success",
        //       });
        //       // 跳转到登录页
        //       this.resetshow = false
        //     }else{
        //         this.$alert('手机验证码错误,请重试',  {
        //           confirmButtonText: '确定',
        //           center:true,
        //           confirmButtonClass:"el-button--success",
        //         });
        //     }
        //   }else {
        //     console.log('error submit!!');
        //     return false;
        //   }
        // })
      },
      // 打开找回密码页
      resetpwd() {
        //通过v-else-if 进入页面
        this.resetshow = true
      },
      // 返回登录页
      gobacklogin() {
        this.resetshow = false
      },
      //表单重置内容事件
      // resetForm(formName) {
      //   this.$refs[formName].resetFields();
      // }
    }
  }

</script>

<style lang="less" scoped>
/deep/.el-radio-button__inner {
  padding: 12px 73px;
}

/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  // color: #FFF;
  background-color: rgb(76, 101, 255);
  border-color: rgb(76, 101, 255);
  box-shadow: -1px 0 0 0 rgb(76, 101, 255);
}

.resetpassword {
  display: flex;
  justify-content: flex-start;
  background-color: white;
  font-size: 15px;
  margin-bottom: 20px;
}

.title {
  font-size: 30px;
  font-weight: bold;
  display: flex;
}

.change {
  font-size: 26px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

// /deep/.el-input__inner {
//   background-color: #F1F0F6 !important;
// }
/deep/ .el-input__inner {
  background: #edefff;
  // border-radius: 12px;
  border: 2px solid #4c65ff;
}

/deep/.el-input__inner:hover {
  background: #ffffff;
  border: 2px solid #4c65ff;
}

/deep/.el-button {
  // background-color: #F1F0F6 !important;
  background: #edefff;
  color: #333333;
  font-weight: bold;
  height: 60px;
  font-size: 26px;
  border: 2px solid #4c65ff;
  // border: none;
}

/deep/.el-button:hover {
  background: #ffffff;
  // color: #409EFF;
  border: 2px solid #4c65ff;
  // background-color: #ecf5ff;
}

.vidid {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.vidi {
  // width:190px;
  // height: 80px;
  background: #d8d8d8;
  display: inline-block;
  margin-left: 20px;
}

.short {
  position: fixed;
  margin-top: 24px;
  margin-right: 40px;
}

.vididd {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.send {
  width: 280px;
  height: 40px;
  line-height: 36px;
  // background: #2EAE95;
  background: #edefff;
  border-radius: 10px;
  margin-left: 20px;
  font-size: 18px;
  color: #333333;
  padding: 0px 25px;
}

.resetchange {
  background-color: white;
  color: #606266;
  font-size: 26px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

// 表单通过验证后 按钮更换的样式
/deep/.iscolorshow {
  background-color: #2c9382 !important;
  color: white;
}
</style>
